import { render, staticRenderFns } from "./DashboardInsights.vue?vue&type=template&id=0668a115&scoped=true"
import script from "./DashboardInsights.vue?vue&type=script&lang=js"
export * from "./DashboardInsights.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0668a115",
  null
  
)

export default component.exports